import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import AuthApi from '../../Services/Authapi';
import AuthCheckComponent from '../../Layouts/Token';
import TableComponent from '../../Layouts/TableComponent';
import ExportButton from '../../Layouts/ExportButton';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import swal from 'sweetalert';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import moment from 'moment';
import ls from 'local-storage';
import {
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Tooltip,
  InputAdornment,
  Avatar,
  IconButton
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import '../Leaves/Leave.css';
import '../LeavesTicket/Ticket.css';
import defaultAvatar from '../../../Images/person.jpg';
import { resolveImageUrl } from '../../../utils/imageUrl';

export const ARCHIVED_TASKS_KEY = 'cherrypik_archived_task_ids_v1';
export const TASK_META_KEY = 'cherrypik_task_history_meta_v1';

const TEST_STATUS_OPTIONS = [
  { id: 'Done', label: 'Done', color: '#047857', bg: '#d1fae5', border: '#a7f3d0' },
  { id: 'Inprogress', label: 'Inprogress', color: '#d97706', bg: '#fef3c7', border: '#fde68a' },
  { id: 'Pending', label: 'Pending', color: '#ca8a04', bg: '#fef9c3', border: '#fef08a' },
  { id: 'Need to discuss', label: 'Need to discuss', color: '#0284c7', bg: '#e0f2fe', border: '#bae6fd' },
  { id: 'Hold', label: 'Hold', color: '#dc2626', bg: '#fee2e2', border: '#fca5a5' }
];

class TaskHistoryArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      tasks: [],
      projects: [],
      allUsers: [],
      selectedProject: 'ALL',
      searchQuery: '',

      taskMeta: this.loadTaskMeta(),
      archivedTaskIds: this.loadArchivedTaskIds(),
      selectedTaskIds: [],
      bulkAction: '',
      isBulkUpdating: false,

      // Drawer state
      drawerOpen: false,
      activeDrawerTask: null,
      drawerActivityOpen: false,
      drawerActivity: [],
      drawerLoadingActivity: false
    };
  }

  loadTaskMeta = () => {
    try {
      const stored = localStorage.getItem(TASK_META_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch (_) {
      return {};
    }
  };

  saveTaskMeta = (newMeta) => {
    try {
      localStorage.setItem(TASK_META_KEY, JSON.stringify(newMeta));
    } catch (_) { }
  };

  loadArchivedTaskIds = () => {
    try {
      const stored = localStorage.getItem(ARCHIVED_TASKS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (_) {
      return [];
    }
  };

  saveArchivedTaskIds = (ids) => {
    try {
      localStorage.setItem(ARCHIVED_TASKS_KEY, JSON.stringify(ids));
    } catch (_) { }
  };

  isUserSuperAdmin = () => {
    try {
      const roles = ls.get('roles') || ls('roles') || (this.props.authUser && this.props.authUser.roles);
      const role = ls.get('role') || ls('role') || (this.props.authUser && this.props.authUser.role);
      const adminRoles = ['super admin', 'admin', 'administrator'];

      if (typeof role === 'string' && adminRoles.includes(role.trim().toLowerCase())) {
        return true;
      }
      if (typeof roles === 'string' && adminRoles.includes(roles.trim().toLowerCase())) {
        return true;
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  };

  getCurrentUserId = () => {
    try {
      let user = ls.get('user') || ls('user');
      if (typeof user === 'string') {
        try {
          user = JSON.parse(user);
        } catch (_) { }
      }
      return (user && (user.id || user._id || user.user_id)) || null;
    } catch (_) {
      return null;
    }
  };

  extractIds = (value) => {
    if (value === null || value === undefined) return [];
    if (Array.isArray(value)) {
      return value
        .map((item) => (typeof item === 'object' && item !== null ? item.id : item))
        .filter((item) => item !== null && item !== undefined);
    }
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) => (typeof item === 'object' && item !== null ? item.id : item))
            .filter((item) => item !== null && item !== undefined);
        }
      } catch (_) { }
      return value
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);
    }
    if (typeof value === 'number') return [value];
    return [];
  };

  isProjectVisibleToUser = (project, userId) => {
    if (!project || !userId) return false;
    const uid = Number(userId);

    const members = (this.extractIds(project.member_ids) || []).map(Number);
    const leads = [
      ...(this.extractIds(project.lead_ids) || []),
      ...(project.lead_id ? this.extractIds(project.lead_id) : [])
    ].map(Number);
    const assignedIds = [...members, ...leads];
    return assignedIds.includes(uid);
  };

  filterProjectsByPermission = (projectsList) => {
    const isSuperAdmin = this.isUserSuperAdmin();
    const currentUserId = this.getCurrentUserId();
    if (isSuperAdmin) return projectsList;
    if (!currentUserId) return [];
    return (projectsList || []).filter((p) => this.isProjectVisibleToUser(p, currentUserId));
  };

  async componentDidMount() {
    await this.initData();
  }

  normalizeTask = (raw) => {
    if (!raw) return raw;
    const t = { ...raw };
    if (!t.project_task_id && t.project_id && t.id) {
      t.project_task_id = `TSK-${t.id}`;
    }
    if (typeof t.sub_tasks === 'string' && t.sub_tasks.trim()) {
      try {
        t.sub_tasks_parsed = JSON.parse(t.sub_tasks);
      } catch (_) {
        t.sub_tasks_parsed = [];
      }
    } else if (Array.isArray(t.sub_tasks)) {
      t.sub_tasks_parsed = t.sub_tasks;
    } else {
      t.sub_tasks_parsed = [];
    }
    return t;
  };

  initData = async () => {
    this.setState({ loading: true });
    try {
      const [projectsRes, usersRes, tasksRes] = await Promise.all([
        AuthApi.getProject(),
        AuthApi.getData(),
        AuthApi.getTasks()
      ]);

      const projectsData = (projectsRes && projectsRes.data) || projectsRes || [];
      const allProjects = Array.isArray(projectsData) ? projectsData.filter((p) => !p.deleted) : [];
      const visibleProjects = this.filterProjectsByPermission(allProjects);

      const usersData = (usersRes && usersRes.data) || usersRes || [];
      const allUsers = Array.isArray(usersData) ? usersData : [];

      let res = tasksRes;
      if (!res || (res.status === false && !Array.isArray(res.data))) {
        if (typeof AuthApi.taskslistbyuserid === 'function') {
          res = await AuthApi.taskslistbyuserid();
        }
      }

      const rawTasks = (res && res.data) || (Array.isArray(res) ? res : []);
      const tasks = Array.isArray(rawTasks) ? rawTasks.map(this.normalizeTask) : [];

      this.setState({
        projects: visibleProjects,
        allUsers,
        tasks,
        loading: false
      });
    } catch (e) {
      console.error('Error initializing Task History Archive data', e);
      this.setState({ loading: false });
    }
  };

  getAssignedUsersForTask = (task) => {
    const { allUsers = [] } = this.state;
    if (!task) return [];

    let candidateIds = [];
    if (task.developer_user_ids !== undefined && task.developer_user_ids !== null) {
      candidateIds = this.extractIds(task.developer_user_ids);
    } else if (task.member_ids !== undefined && task.member_ids !== null) {
      candidateIds = this.extractIds(task.member_ids);
    } else if (task.developer_user_id !== undefined && task.developer_user_id !== null) {
      candidateIds = [task.developer_user_id];
    } else if (task.assigned_developer !== undefined && task.assigned_developer !== null) {
      candidateIds = [task.assigned_developer];
    }

    const matchedUsers = [];
    const seenIds = new Set();

    candidateIds.forEach((idVal) => {
      const numId = Number(idVal);
      if (!numId || seenIds.has(numId)) return;
      const found = allUsers.find((u) => Number(u.id) === numId);
      if (found) {
        seenIds.add(numId);
        matchedUsers.push(found);
      }
    });

    return matchedUsers;
  };

  getEffectiveTaskDate = (task) => {
    if (!task) return '';
    const meta = (this.state.taskMeta && this.state.taskMeta[task.id]) || {};
    const effective =
      meta.done_date ||
      task.done_date ||
      task.completed_at ||
      task.updated_at ||
      task.task_date ||
      task.created_at;

    if (!effective) return '';
    const m = moment(effective);
    return m.isValid() ? m.format('YYYY-MM-DD') : String(effective);
  };

  matchesSearchQuery = (task, q) => {
    if (!q) return true;
    q = q.toLowerCase();
    const meta = (this.state.taskMeta && this.state.taskMeta[task.id]) || {};

    // 1. DATE SEARCH
    const effectiveDateStr = this.getEffectiveTaskDate(task);
    if (effectiveDateStr) {
      const m = moment(effectiveDateStr);
      if (m.isValid()) {
        const formats = ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', 'D/M/YYYY', 'D-M-YYYY', 'MMM DD, YYYY'];
        for (const fmt of formats) {
          if (m.format(fmt).toLowerCase().includes(q)) return true;
        }
      }
    }

    // 2. TASK NAME SEARCH
    const taskName = String(task.task || '').toLowerCase();
    const taskId = String(task.project_task_id || '').toLowerCase();
    const taskNumId = String(task.id || '');
    if (taskName.includes(q) || taskId.includes(q) || taskNumId === q) return true;

    // 3. BRANCH SEARCH
    const branchName = String((meta.branch_name !== undefined ? meta.branch_name : task.branch_name) || '').toLowerCase();
    const branchCreatedFrom = String((meta.branch_created_from !== undefined ? meta.branch_created_from : task.branch_created_from) || '').toLowerCase();
    if (branchName.includes(q) || branchCreatedFrom.includes(q)) return true;

    // 4. PROJECT NAME SEARCH
    const projectName = String(task.project_name || task.project || '').toLowerCase();
    if (projectName.includes(q)) return true;

    // 5. ASSIGN DEVELOPER SEARCH
    const assignedUsers = this.getAssignedUsersForTask(task);
    const matchesUser = assignedUsers.some((u) => {
      const first = String(u.firstName || '').toLowerCase();
      const last = String(u.lastName || '').toLowerCase();
      const full = `${first} ${last}`.trim();
      const name = String(u.name || '').toLowerCase();
      const email = String(u.email || '').toLowerCase();
      return (
        first.includes(q) ||
        last.includes(q) ||
        full.includes(q) ||
        name.includes(q) ||
        email.includes(q)
      );
    });
    if (matchesUser) return true;

    return false;
  };

  getFilteredTasks = () => {
    const { tasks, selectedProject, searchQuery, taskMeta, projects, archivedTaskIds = [] } = this.state;
    const isSuperAdmin = this.isUserSuperAdmin();
    const currentUserId = this.getCurrentUserId();

    const archivedSet = new Set((archivedTaskIds || []).map(String));

    // Archive shows ONLY Done tasks that ARE archived
    let list = tasks.filter((t) => {
      const s = String(t.status || '').toLowerCase().trim();
      if (s !== 'done') return false;
      const isArchived = archivedSet.has(String(t.id)) || (taskMeta[t.id] && taskMeta[t.id].is_archived);
      return Boolean(isArchived);
    });

    // Permission filtering for non-admin
    if (!isSuperAdmin) {
      const visibleProjectNames = new Set(
        (projects || []).map((p) => String(p.project_name || '').trim().toLowerCase())
      );
      list = list.filter((task) => {
        const pName = String(task.project_name || '').trim().toLowerCase();
        if (pName && visibleProjectNames.has(pName)) return true;
        const assignedUsers = this.getAssignedUsersForTask(task);
        const taskMemberIds = (this.extractIds(task.member_ids || task.developer_user_ids) || []).map(Number);
        return Boolean(
          currentUserId && (
            Number(task.developer_user_id) === Number(currentUserId) ||
            Number(task.assign_by_id || task.assign_by) === Number(currentUserId) ||
            assignedUsers.some((u) => Number(u.id) === Number(currentUserId)) ||
            taskMemberIds.includes(Number(currentUserId))
          )
        );
      });
    }

    // Project filter
    if (selectedProject !== 'ALL') {
      list = list.filter((t) => (t.project_name || '').trim() === selectedProject.trim());
    }

    // Search query
    const q = (searchQuery || '').trim();
    if (q) {
      list = list.filter((t) => this.matchesSearchQuery(t, q));
    }

    return list;
  };

  handleBulkActionSubmit = () => {
    const { selectedTaskIds = [], bulkAction = '' } = this.state;
    if (!bulkAction || selectedTaskIds.length === 0) {
      swal('Warning', 'Please select tasks and a bulk action to apply.', 'warning');
      return;
    }

    if (bulkAction === 'restore') {
      swal({
        title: 'Confirm Bulk Restore',
        text: `Are you sure you want to restore ${selectedTaskIds.length} selected task(s)? These tasks will be moved back to Task History.`,
        icon: 'warning',
        buttons: ['Cancel', 'Yes, Restore'],
        dangerMode: false
      }).then((willRestore) => {
        if (willRestore) {
          this.restoreSelectedTasks();
        }
      });
    } else if (bulkAction === 'delete') {
      swal({
        title: 'Are you sure?',
        text: `Once deleted, you will not be able to recover ${selectedTaskIds.length} task(s)!`,
        icon: 'warning',
        buttons: ['Cancel', 'Yes, Delete'],
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          this.deleteSelectedTasks();
        }
      });
    }
  };

  restoreSelectedTasks = () => {
    const { selectedTaskIds = [], archivedTaskIds = [], taskMeta = {} } = this.state;
    const count = selectedTaskIds.length;
    const selectedSet = new Set(selectedTaskIds.map(String));

    swal({
      title: 'Restoring Tasks',
      text: 'Please wait...',
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    // Remove from archived list
    const updatedArchivedIds = (archivedTaskIds || []).filter((id) => !selectedSet.has(String(id)));
    this.saveArchivedTaskIds(updatedArchivedIds);

    // Update taskMeta
    const updatedMeta = { ...taskMeta };
    selectedTaskIds.forEach((id) => {
      if (updatedMeta[id]) {
        updatedMeta[id] = {
          ...updatedMeta[id],
          is_archived: false,
          restored_at: new Date().toISOString()
        };
      }
    });
    this.saveTaskMeta(updatedMeta);

    this.setState({
      archivedTaskIds: updatedArchivedIds,
      taskMeta: updatedMeta,
      selectedTaskIds: [],
      bulkAction: ''
    });

    swal('Success', `${count} task(s) restored successfully!`, 'success');
  };

  deleteSelectedTasks = async () => {
    const { selectedTaskIds = [], archivedTaskIds = [], taskMeta = {}, tasks = [] } = this.state;
    const count = selectedTaskIds.length;
    const selectedSet = new Set(selectedTaskIds.map(String));

    this.setState({ isBulkUpdating: true });

    swal({
      title: 'Deleting Tasks',
      text: 'Please wait...',
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode()
    });

    // Call API for each selected task
    try {
      await Promise.all(
        selectedTaskIds.map((id) => {
          if (typeof AuthApi.deletetask === 'function') {
            return AuthApi.deletetask(id);
          }
          return Promise.resolve(true);
        })
      );
    } catch (e) {
      console.error('Error deleting tasks in bulk', e);
    }

    // Remove from archived list
    const updatedArchivedIds = (archivedTaskIds || []).filter((id) => !selectedSet.has(String(id)));
    this.saveArchivedTaskIds(updatedArchivedIds);

    // Remove from tasks array in state
    const updatedTasks = tasks.filter((t) => !selectedSet.has(String(t.id)));

    // Clean up taskMeta
    const updatedMeta = { ...taskMeta };
    selectedTaskIds.forEach((id) => {
      delete updatedMeta[id];
    });
    this.saveTaskMeta(updatedMeta);

    this.setState({
      tasks: updatedTasks,
      archivedTaskIds: updatedArchivedIds,
      taskMeta: updatedMeta,
      selectedTaskIds: [],
      bulkAction: '',
      isBulkUpdating: false
    });

    swal('Success', `${count} task(s) deleted successfully!`, 'success');
  };

  downloadTaskHistoryArchiveXLSX = async () => {
    try {
      const filteredTasks = this.getFilteredTasks();
      const { selectedTaskIds = [], taskMeta = {} } = this.state;

      const tasksToExport = (selectedTaskIds && selectedTaskIds.length > 0)
        ? filteredTasks.filter((t) => selectedTaskIds.includes(t.id))
        : filteredTasks;

      if (!tasksToExport || tasksToExport.length === 0) {
        swal('Info', 'No archived tasks available to download.', 'info');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Archive Task History');

      // Define columns
      worksheet.columns = [
        { header: 'Sr. No.', key: 'sr_no', width: 10 },
        { header: 'Date', key: 'done_date', width: 15 },
        { header: 'Task Name', key: 'task', width: 35 },
        { header: 'Branch Name', key: 'branch_name', width: 25 },
        { header: 'Branch-Created From', key: 'branch_created_from', width: 25 },
        { header: 'Project Name', key: 'project_name', width: 20 },
        { header: 'Assign Developer', key: 'assigned_developer', width: 25 },
        { header: 'Status', key: 'status', width: 15 },
        { header: 'Local Test', key: 'local_test', width: 15 },
        { header: 'Staging Test', key: 'staging_test', width: 15 }
      ];

      // Style header row
      const headerRow = worksheet.getRow(1);
      headerRow.height = 28;
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF036DDA' }
        };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FFB0C4DE' } },
          left: { style: 'thin', color: { argb: 'FFB0C4DE' } },
          bottom: { style: 'thin', color: { argb: 'FFB0C4DE' } },
          right: { style: 'thin', color: { argb: 'FFB0C4DE' } }
        };
      });

      // Add data rows
      tasksToExport.forEach((task, index) => {
        const meta = taskMeta[task.id] || {};
        const effectiveDate = this.getEffectiveTaskDate(task);
        const formattedDate = effectiveDate ? moment(effectiveDate).format('DD/MM/YYYY') : '-';

        const branchName = meta.branch_name !== undefined ? meta.branch_name : (task.branch_name || '');
        const branchCreatedFrom = meta.branch_created_from !== undefined ? meta.branch_created_from : (task.branch_created_from || '');

        const assignedUsers = this.getAssignedUsersForTask(task);
        const developerNames = (assignedUsers && assignedUsers.length > 0)
          ? assignedUsers.map((u) => (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name || 'User')).join(', ')
          : 'Unassigned';

        const status = task.status || 'Done';
        const localTest = (meta.local_test !== undefined ? meta.local_test : task.local_test) || 'Pending';
        const stagingTest = (meta.staging_test !== undefined ? meta.staging_test : task.staging_test) || 'Pending';

        const row = worksheet.addRow({
          sr_no: index + 1,
          done_date: formattedDate,
          task: task.task || '-',
          branch_name: branchName || '-',
          branch_created_from: branchCreatedFrom || '-',
          project_name: task.project_name || '-',
          assigned_developer: developerNames,
          status: status,
          local_test: localTest,
          staging_test: stagingTest
        });

        row.height = 22;
        row.eachCell((cell, colNumber) => {
          cell.font = { size: 10 };
          if ([1, 2, 6, 8, 9, 10].includes(colNumber)) {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          } else {
            cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
          }
          cell.border = {
            top: { style: 'thin', color: { argb: 'FFE2E8F0' } },
            left: { style: 'thin', color: { argb: 'FFE2E8F0' } },
            bottom: { style: 'thin', color: { argb: 'FFE2E8F0' } },
            right: { style: 'thin', color: { argb: 'FFE2E8F0' } }
          };
        });
      });

      const dateStr = moment().format('DD-MM-YYYY');
      const projectSuffix = this.state.selectedProject && this.state.selectedProject !== 'ALL'
        ? `_${this.state.selectedProject.replace(/\s+/g, '_')}`
        : '';
      const fileName = `Archive_Task_History${projectSuffix}_${dateStr}.xlsx`;

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
    } catch (error) {
      console.error('Error exporting archive task history to Excel:', error);
      swal('Error', 'Failed to download Task History XLSX. Please try again.', 'error');
    }
  };

  renderBottomBarControls = () => {
    const { selectedTaskIds = [], bulkAction = '', isBulkUpdating = false } = this.state;

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
        <div className="leave-ticket-bulk-actions">
          <Select
            className="custom-filter-select"
            value={bulkAction}
            onChange={(e) => this.setState({ bulkAction: e.target.value })}
            style={{ marginRight: '10px', minWidth: '150px', backgroundColor: 'transparent' }}
            displayEmpty
            disabled={isBulkUpdating}
            MenuProps={{ classes: { paper: 'leave-status-menu' } }}
          >
            <MenuItem value="">
              <em>Select Bulk Action</em>
            </MenuItem>
            <MenuItem value="delete">
              Delete Task
            </MenuItem>
            <MenuItem value="restore">
              Restore Task
            </MenuItem>
          </Select>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleBulkActionSubmit}
            disabled={selectedTaskIds.length === 0 || !bulkAction || isBulkUpdating}
          >
            GO
          </Button>
        </div>
        <ExportButton
          label="Download Task History XLSX"
          onClick={this.downloadTaskHistoryArchiveXLSX}
        />
      </div>
    );
  };


  renderTestStatusBadge = (statusValue) => {
    const matched = TEST_STATUS_OPTIONS.find(
      (opt) => opt.id.toLowerCase() === String(statusValue || '').toLowerCase()
    ) || {
      id: statusValue || 'Pending',
      label: statusValue || 'Pending',
      color: '#64748b',
      bg: '#f1f5f9',
      border: '#cbd5e1'
    };

    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2px 10px',
          borderRadius: 12,
          fontSize: '0.74rem',
          fontWeight: 600,
          color: matched.color,
          backgroundColor: matched.bg,
          border: `1px solid ${matched.border}`
        }}
      >
        {matched.label || matched.id}
      </span>
    );
  };

  handleOpenDrawer = (task) => {
    this.setState({
      drawerOpen: true,
      activeDrawerTask: task
    });
  };

  handleCloseDrawer = () => {
    this.setState({
      drawerOpen: false,
      activeDrawerTask: null
    });
  };

  render() {
    const {
      loading,
      projects,
      selectedProject,
      searchQuery,
      taskMeta,
      drawerOpen,
      activeDrawerTask
    } = this.state;

    const filteredTasks = this.getFilteredTasks();
    const isSuperAdmin = this.isUserSuperAdmin();

    const TABLE_HEADERS = [
      { id: 'select', label: '', sortable: false, disablePadding: true, style: { width: '60px', minWidth: '60px', textAlign: 'center' } },
      { id: 'done_date', label: 'Date', sortable: false, style: { width: '110px', minWidth: '105px', textAlign: 'left', whiteSpace: 'nowrap' } },
      { id: 'task', label: 'Task Name', sortable: true, style: { minWidth: '150px', maxWidth: '240px', whiteSpace: 'normal', paddingLeft: '12px' } },
      { id: 'branch_name', label: 'Branch Name', sortable: false, style: { minWidth: '150px' } },
      { id: 'branch_created_from', label: 'Branch-Created From', sortable: false, style: { minWidth: '165px' } },
      { id: 'project_name', label: 'Project Name', sortable: true, style: { minWidth: '100px', textAlign: 'left' } },
      ...(isSuperAdmin ? [{ id: 'assigned_developer', label: 'Assign Developer', sortable: false, style: { minWidth: '130px', textAlign: 'center', whiteSpace: 'nowrap' } }] : []),
      { id: 'status', label: 'Status', sortable: false, style: { minWidth: '85px', textAlign: 'center', whiteSpace: 'nowrap' } },
      { id: 'local_test', label: 'Local Test', sortable: false, style: { minWidth: '135px', textAlign: 'center', whiteSpace: 'nowrap' } },
      { id: 'staging_test', label: 'Staging Test', sortable: false, style: { minWidth: '120px', textAlign: 'center', whiteSpace: 'nowrap', paddingRight: '12px' } }
    ];

    const pageContent = (
      <div style={{ marginBottom: '11%' }}>
        {/* Breadcrumb Card */}
        <div className="holiday-breadcrumb-card">
          <Breadcrumb
            {...this.props}
            primaryPageName="Tasks"
            primaryPageLink="/tasks"
            isSecondaryPage={true}
            secondaryPageName="Task History"
            secondaryPageLink="/tasks/history"
            isTertiaryPage={true}
            tertiaryPageName="Archive Task History"
          />
        </div>

        {/* Table Container */}
        <TableComponent
          {...this.props}
          modelName="Archive Task History"
          tableTh={TABLE_HEADERS}
          selected={this.state.selectedTaskIds}
          onSelectionChange={(selected) => this.setState({ selectedTaskIds: selected })}
          bottomBarContent={this.renderBottomBarControls()}
          onRowClick={(row) => this.handleOpenDrawer(row)}
          actionBtns={[]}
          extraHeaderContent={
            <div className="holiday-toolbar-controls">
              {/* Project Filter */}
              <FormControl variant="outlined" className="holiday-year-filter" style={{ width: 130, minWidth: 120 }}>
                <InputLabel id="archive-project-filter-label" style={{ color: '#036dda', fontSize: '0.85rem' }}>
                  Project
                </InputLabel>
                <Select
                  labelId="archive-project-filter-label"
                  label="Project"
                  value={selectedProject}
                  onChange={(e) => this.setState({ selectedProject: e.target.value })}
                  IconComponent={(props) => (
                    <ExpandMoreIcon {...props} style={{ color: '#036dda', cursor: 'pointer' }} />
                  )}
                  style={{ height: '40px' }}
                  MenuProps={{
                    disableScrollLock: true,
                    PaperProps: {
                      className: 'holiday-year-menu',
                      style: { maxHeight: 280 }
                    }
                  }}
                >
                  <MenuItem value="ALL">All Projects</MenuItem>
                  {projects.map((p) => (
                    <MenuItem key={p.id || p.project_name} value={p.project_name}>
                      {p.project_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Search Field */}
              <div className="holiday-search-wrapper" style={{ minWidth: 230 }}>
                <TextField
                  className="holiday-search-field hardik"
                  label="Search"
                  value={searchQuery}
                  onChange={(e) => this.setState({ searchQuery: e.target.value })}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: searchQuery !== '',
                    style: {
                      color: '#036dda',
                      transform: searchQuery !== '' ? 'translate(14px, -6px) scale(0.75)' : 'translate(14px, 11px) scale(1)',
                      transition: 'transform 0.2s ease-in-out'
                    }
                  }}
                  InputProps={{
                    style: { borderRadius: '25px', height: '40px' },
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchQuery && (
                          <ClearIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({ searchQuery: '' });
                            }}
                            style={{ cursor: 'pointer', marginRight: 4, fontSize: 18 }}
                          />
                        )}
                        <SearchIcon style={{ cursor: 'pointer', color: '#036dda', fontSize: 20 }} />
                      </InputAdornment>
                    )
                  }}
                />
              </div>
            </div>
          }
          tableData={filteredTasks.map((task) => {
            const meta = taskMeta[task.id] || {};
            const assignedUsers = this.getAssignedUsersForTask(task);

            return {
              ...task,
              done_date: (
                <div style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', width: '100%' }}>
                  <span style={{ fontSize: '0.76rem', color: '#64748b', fontWeight: 500 }}>
                    {this.getEffectiveTaskDate(task)
                      ? moment(this.getEffectiveTaskDate(task)).format('DD/MM/YYYY')
                      : '-'}
                  </span>
                </div>
              ),
              task: (
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    this.handleOpenDrawer(task);
                  }}
                  title={task.task}
                  className="tm-history-task-title"
                  style={{
                    cursor: 'pointer',
                    fontWeight: 400,
                    fontSize: '0.76rem',
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    maxWidth: '240px',
                    // paddingLeft: '6px',
                    lineHeight: 1.4,
                    display: '-webkit-box',
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                  }}
                >
                  <span>{task.task}</span>
                </div>
              ),
              branch_name: (
                <span style={{ fontSize: '0.76rem', color: '#334155' }}>
                  {meta.branch_name !== undefined ? meta.branch_name : (task.branch_name || '-')}
                </span>
              ),
              branch_created_from: (
                <span style={{ fontSize: '0.76rem', color: '#334155' }}>
                  {meta.branch_created_from !== undefined ? meta.branch_created_from : (task.branch_created_from || '-')}
                </span>
              ),
              project_name: (
                <div style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', width: '100%' }}>
                  <span style={{ fontSize: '0.76rem', fontWeight: 500, color: '#334155' }}>
                    {task.project_name || '-'}
                  </span>
                </div>
              ),
              assigned_developer: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  {assignedUsers.length > 0 ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {assignedUsers.slice(0, 2).map((user) => {
                        const displayName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || 'User';
                        const photoSrc = (user && user.photo && String(user.photo).trim() !== '') ? resolveImageUrl(user.photo) : defaultAvatar;
                        return (
                          <Tooltip key={user.id} title={displayName}>
                            <Avatar
                              src={photoSrc}
                              imgProps={{
                                onError: (e) => {
                                  if (e.target.src !== defaultAvatar) {
                                    e.target.src = defaultAvatar;
                                  }
                                }
                              }}
                              style={{
                                width: 26,
                                height: 26,
                                marginLeft: user.id === 0 ? 0 : -8,
                                border: '2px solid #ffffff',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
                                backgroundColor: 'transparent',
                                cursor: 'pointer',
                              }}
                            />
                          </Tooltip>
                        );
                      })}
                      {assignedUsers.length > 2 && (
                        <span style={{ fontSize: '0.72rem', color: '#64748b', fontWeight: 600 }}>
                          +{assignedUsers.length - 2}
                        </span>
                      )}
                    </div>
                  ) : (
                    <span style={{ color: '#94a3b8', fontSize: '0.76rem' }}>-</span>
                  )}
                </div>
              ),
              status: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '2px 10px',
                      borderRadius: 12,
                      fontSize: '0.74rem',
                      fontWeight: 600,
                      color: '#047857',
                      backgroundColor: '#d1fae5',
                      border: '1px solid #a7f3d0'
                    }}
                  >
                    Done
                  </span>
                </div>
              ),
              local_test: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  {this.renderTestStatusBadge(
                    (meta.local_test !== undefined ? meta.local_test : task.local_test) || 'Pending'
                  )}
                </div>
              ),
              staging_test: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                  {this.renderTestStatusBadge(
                    (meta.staging_test !== undefined ? meta.staging_test : task.staging_test) || 'Pending'
                  )}
                </div>
              )
            };
          })}
          tableCount={filteredTasks.length}
          isLoading={loading}
          shellClassName="holiday-table-shell tm-history-table-shell"
          colNameToShow={[
            'select',
            'done_date',
            'task',
            'branch_name',
            'branch_created_from',
            'project_name',
            ...(isSuperAdmin ? ['assigned_developer'] : []),
            'status',
            'local_test',
            'staging_test'
          ]}
        />
      </div>
    );

    return (
      <div>
        <AuthCheckComponent authToken={this.props.authToken} />
        <Header
          {...this.props}
          authUser={this.props.authUser}
          setAutUser={this.props.setAutUser}
          component={pageContent}
        />
        <Footer {...this.props} />

        {/* Task Details Drawer (if task clicked) */}
        {drawerOpen && activeDrawerTask && (
          <div
            className="tm-history-drawer-backdrop"
            onClick={this.handleCloseDrawer}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.4)',
              zIndex: 1300,
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <div
              className="tm-history-drawer-content"
              onClick={(e) => e.stopPropagation()}
              style={{
                width: '520px',
                maxWidth: '90vw',
                height: '100%',
                backgroundColor: '#ffffff',
                boxShadow: '-4px 0 24px rgba(0,0,0,0.15)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }}
            >
              <div
                style={{
                  padding: '16px 20px',
                  borderBottom: '1px solid #e2e8f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <div>
                  <span style={{ fontSize: '0.8rem', color: '#036dda', fontWeight: 600 }}>
                    {activeDrawerTask.project_name || 'Task Detail'}
                  </span>
                  <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b' }}>
                    {activeDrawerTask.task}
                  </h3>
                </div>
                <IconButton size="small" onClick={this.handleCloseDrawer}>
                  <CloseIcon />
                </IconButton>
              </div>

              <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#64748b' }}>
                    DESCRIPTION
                  </label>
                  <div
                    style={{
                      marginTop: 6,
                      fontSize: '0.85rem',
                      color: '#334155',
                      lineHeight: 1.6,
                      backgroundColor: '#f8fafc',
                      padding: 12,
                      borderRadius: 6
                    }}
                    dangerouslySetInnerHTML={{ __html: activeDrawerTask.description || '<em>No description provided</em>' }}
                  />
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                  <div>
                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#64748b' }}>
                      DATE
                    </label>
                    <div style={{ marginTop: 4, fontSize: '0.84rem', color: '#1e293b' }}>
                      {this.getEffectiveTaskDate(activeDrawerTask) || '-'}
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#64748b' }}>
                      STATUS
                    </label>
                    <div style={{ marginTop: 4 }}>
                      <span
                        style={{
                          display: 'inline-block',
                          padding: '2px 8px',
                          borderRadius: 10,
                          fontSize: '0.72rem',
                          fontWeight: 600,
                          color: '#047857',
                          backgroundColor: '#d1fae5'
                        }}
                      >
                        Done (Archived)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(TaskHistoryArchive);
